export const formatNopol = (nopol) => {
  let tnkbDaerah = nopol?.substr(0,1);
  let tnkbSubDaerah = nopol?.substr(2,3);
  let tnkbNomor = nopol?.substr(5,4);

  let result = tnkbDaerah + '-' + tnkbNomor + '-' + tnkbSubDaerah;

  return result;
}

export const formatSubmitNopol = (tnkb_daerah, tnkb_sub_daerah, tnkb_nomor) => {

  function leftPad(width, string, padding) {
    return width <= string.length ? string : leftPad(width, padding + string, padding);
  }

  function rightPad(width, string, padding) {
    return width <= string.length ? string : rightPad(width, string + padding, padding);
  }

  return (rightPad(2, tnkb_daerah, ' ') + rightPad(3, tnkb_sub_daerah, ' ') + leftPad(4, tnkb_nomor, ' '));
};

export const formatMoney = (number) => {
  if (typeof number !== "number") {
    number = Number(number);
    if (isNaN(number)) return "-";
  }

  return new Intl.NumberFormat("id-ID", {
    maximumFractionDigits: 0,
  }).format(number);
};